// src/pages/OrgsteadHome.jsx
import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";

const OrgsteadHome = () => {
  const authState = useSelector((state) => state.authReducer || {});
  const isLogged = authState?.isLogged || false;
  const userName = authState?.user?.name || "User";

  const [activeTab, setActiveTab] = useState("Cognition");
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };

  const groupNames = [
    { label: "Cognition", emoji: "🧠" },
    { label: "Knowledge", emoji: "📚" },
    { label: "Learning", emoji: "🎓" },
    { label: "Intelligence", emoji: "📊" },
    { label: "Reinforcement", emoji: "👏" },
    { label: "Engagement", emoji: "🌐" },
  ];

  const menuButtons1 = [

    // 🧠 COGNITION
    { label: "Deep Thinking", emoji: "🧠", link: "/fivewhys-analysis-home", group: "Cognition" },
    { label: "Decision Intelligence", emoji: "⚡", link: "/decision-intelligence-home", group: "Cognition" },
    { label: "POV", emoji: "👁️", link: "/povify-home", group: "Cognition" },
    { label: "VisualBrief", emoji: "🧪", link: "/visualbrief-home", group: "Cognition" },
    { label: "AI Counselling", emoji: "🤖", link: "/aicounselling", group: "Cognition" },

    // 📚 KNOWLEDGE
    { label: "Immersive Books", emoji: "📚", link: "/orgstead-bookworld", group: "Knowledge" },
    { label: "Immersive Bookshelf", emoji: "📖", link: "/bookshelf", group: "Knowledge" },
    { label: "Chronicles", emoji: "📔", link: "/life-chronicles-home", group: "Knowledge" },
    { label: "Diary", emoji: "📓", link: "/mydiary-home", group: "Knowledge" },
    { label: "Journal", emoji: "📘", link: "/myjournal-home", group: "Knowledge" },

    // 🎓 LEARNING
    { label: "Assignments", emoji: "📝", link: "/assignments-others", group: "Learning" },
    { label: "Practice Test", emoji: "⏱️", link: "/practice-mcqothers", group: "Learning" },
    { label: "Certification Test", emoji: "📜", link: "/certification-test-others", group: "Learning" },
    { label: "Certificates", emoji: "🏅", link: "/my-certificates-others", group: "Learning" },

    // 📊 INTELLIGENCE
    { label: "Intelligence Dashboard", emoji: "📊", link: "/intelligence-dashboard-home", group: "Intelligence" },
    { label: "Cognitive Evolution", emoji: "📈", link: "/cognitive-evolution-home", group: "Intelligence" },

    // 👏 REINFORCEMENT
    { label: "Applause", emoji: "👏", link: "/applause-hub-home", group: "Reinforcement" },
    { label: "IKIGAI", emoji: "🎯", link: "/ikigai-home", group: "Reinforcement" },
    { label: "Cognitive Focus", emoji: "⏳", link: "/focus-timer-home", group: "Reinforcement" },

    // 🌐 ENGAGEMENT
    { label: "Counsellors", emoji: "🧑‍🏫", link: "/think5whys-counsellors", group: "Engagement" },
    { label: "Live Intelligence Sessions", emoji: "🎥", link: "/event-flow-home", group: "Engagement" },
    { label: "InsightCast", emoji: "🎙️", link: "/podcast-mylist", group: "Engagement" },

  ];

  const filteredButtons = menuButtons1.filter(
    (btn) => btn.group === activeTab
  );

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-b from-slate-950 via-slate-900 to-black text-slate-100 font-sans">

      {/* ================= HEADER ================= */}
      <header className="sticky top-0 z-50 backdrop-blur-md bg-black/80 border-b border-cyan-900 shadow-[0_4px_20px_rgba(0,255,255,0.08)]">
        <div className="px-4 py-1 flex items-center justify-between">

          {/* LEFT */}
          <div className="flex flex-col">
            <div className="flex items-center gap-2">
              <div className="text-2xl lg:text-3xl font-black tracking-wide text-cyan-100">
                Orgstead
              </div>

              <div className="lg:flex px-2 py-[2px] rounded-full bg-cyan-900/40 border border-cyan-700 text-[10px] tracking-widest uppercase text-cyan-200">
                Intelligence Layer
              </div>
            </div>

            <div className="text-[11px] lg:text-xs tracking-wide text-slate-400 mt-[2px]">
              Powered by Think5Whys Cognitive Infrastructure
            </div>
          </div>

          {/* DESKTOP RIGHT */}
          <div className="hidden md:flex items-center gap-3">

            {isLogged ? (
              <>
                <div className="px-3 py-1 rounded-full bg-slate-800 border border-slate-700 text-xs text-slate-200">
                  {userName}
                </div>

                <button
                  onClick={handleLogout}
                  className="w-10 h-10 rounded-xl bg-red-600/90 hover:bg-red-700 transition-all duration-300 text-white shadow-lg"
                  title="Logout"
                >
                  ⏻
                </button>
              </>
            ) : (
              <button
                onClick={() => navigate("/login")}
                className="px-4 py-2 rounded-xl border border-cyan-700 bg-slate-900 hover:bg-cyan-900/30 text-sm text-cyan-100 transition-all duration-300"
              >
                🔐 Login
              </button>
            )}

          </div>

          {/* MOBILE MENU */}
          <button
            onClick={() => setIsMobileMenuOpen((s) => !s)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg bg-slate-900 border border-slate-700 text-white text-xl"
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? "×" : "☰"}
          </button>
        </div>
      </header>

      {/* ================= MOBILE MENU ================= */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-slate-950 border-b border-slate-800 px-4 py-4 animate-[fadeIn_0.3s_ease-in-out]">
          {isLogged ? (
            <div className="flex flex-col items-center gap-3">
              <div className="px-3 py-1 rounded-full bg-slate-800 border border-slate-700 text-xs text-slate-200">
                {userName}
              </div>
              <button
                onClick={handleLogout}
                className="w-12 h-12 rounded-xl bg-red-600 hover:bg-red-700 text-white"
              >
                ⏻
              </button>
            </div>
          ) : (
            <div className="flex justify-center">
              <Link
                to="/login"
                className="px-5 py-2 rounded-xl border border-cyan-700 bg-slate-900 text-cyan-100"
              >
                🔐 Login
              </Link>
            </div>
          )}
        </div>
      )}

      {/* ================= MAIN BODY ================= */}
      <div className="min-h-[70vh] flex flex-col">
        {/* TOP NAV */}
        <div className="bg-gradient-to-r from-cyan-950 via-slate-900 to-cyan-950 border-b border-cyan-900 text-xs lg:text-sm py-2">
          <div className="px-2 flex flex-wrap justify-center gap-3 lg:gap-5">
            <a href="/orgstead-why" className="hover:text-cyan-300 transition">
              🧠 About
            </a>
            <Link to="/litenshort" className="hover:text-cyan-300 transition">
              📰 News
            </Link>
            <a href="/tonic-leaderboard" className="hover:text-cyan-300 transition">
              🏆 Rankings
            </a>
            <a href="/orderflow-earning-estimator" className="hover:text-cyan-300 transition">
              💰 Insights
            </a>
            <a href="/agenticsim" className="hover:text-cyan-300 transition">
              🤖 Thinky
            </a>
          </div>
        </div>

        {/* LIGHT BAR */}
        <div className="relative w-full h-6 bg-black overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-cyan-500/30 to-transparent blur-md"></div>
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-cyan-400 to-transparent h-[1px] top-1/2 -translate-y-1/2"></div>
        </div>

        {/* CATEGORY TABS */}
        <div className="px-3 py-1 border-b border-slate-800 bg-black/40 backdrop-blur-sm">
          <div className="grid grid-cols-3 lg:grid-cols-6 gap-2 place-items-center">
            {groupNames.map((group) => (
              <button
                key={group.label}
                onClick={() => setActiveTab(group.label)}
                className={`group relative overflow-hidden flex flex-col items-center justify-center w-full min-h-[72px] px-1 py-1 rounded-2xl border transition-all duration-300 ${
                  activeTab === group.label
                    ? "bg-gradient-to-br from-cyan-700 to-teal-700 border-cyan-400 text-white shadow-[0_0_20px_rgba(0,255,255,0.25)] scale-[1.02]"
                    : "bg-slate-900/70 border-slate-700 text-slate-300 hover:border-cyan-700 hover:bg-slate-800"
                }`}
                aria-pressed={activeTab === group.label}
              >
                <span className="text-lg mb-[2px]">
                  {group.emoji}
                </span>
                <span className="text-[10px] lg:text-[11px] font-medium tracking-wide text-center leading-tight">
                  {group.label}
                </span>
              </button>
            ))}
          </div>
        </div>

        <div className="mb-2 text-center">
          <div className="w-full flex items-center justify-center gap-2 px-4 py-1 bg-cyan-950/50 border border-cyan-900 text-cyan-100 text-xs lg:text-sm tracking-wide">
            <span className="text-lg">
              {
                groupNames.find((g) => g.label === activeTab)?.emoji
              }
            </span>
            <span>
              {activeTab} Layer
            </span>
          </div>
        </div>

        {/* MAIN GRID */}
        <main className="flex-grow w-full px-3 py-1">
          <div className="p-1">
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 xl:grid-cols-6 gap-3">
              {filteredButtons.length === 0 ? (
                <div className="col-span-full text-center text-slate-500 py-10">
                  No items in this category.
                </div>
              ) : (
                filteredButtons.map((btn, idx) => (
                  <button
                    key={`${btn.label}-${idx}`}
                    onClick={() => navigate(btn.link)}
                    className="group relative overflow-hidden min-h-[48px] rounded-xl border border-slate-800 bg-gradient-to-br from-slate-900 via-slate-900 to-cyan-950/20 hover:border-cyan-600 transition-all duration-300 hover:scale-[1.02] hover:shadow-[0_6px_18px_rgba(0,255,255,0.10)]"
                    title={btn.label}
                  >
                    <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition duration-300 bg-gradient-to-br from-cyan-500/5 via-transparent to-teal-500/5"></div>
                    <div className="relative z-10 flex flex-col items-center justify-center h-full px-2 py-2 text-center">
                      <div className="text-lg lg:text-xl mb-1 transition-transform duration-300 group-hover:scale-110">
                        {btn.emoji}
                      </div>
                      <div className="text-xs lg:text-sm font-semibold leading-snug text-slate-100">
                        {btn.label}
                      </div>
                    </div>
                  </button>
                ))
              )}
            </div>
          </div>
        </main>
        {/* LIGHT BAR */}
        <div className="relative w-full h-4 bg-black overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-cyan-500/30 to-transparent blur-md"></div>
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-cyan-400 to-transparent h-[1px] top-1/2 -translate-y-1/2"></div>
        </div>
      </div>

      {/* ================= FOOTER ================= */}
      <footer className="bg-black border-t border-slate-800 text-white py-3">
        <div className="px-3 flex flex-col lg:flex-row items-center justify-between gap-1">
          <div className="text-xs lg:text-sm text-slate-400"> © 2026 Think5Whys Global DeepTech Solutions.</div>
          <div className="flex flex-wrap justify-center gap-4 text-xs lg:text-sm">
            <Link to="/about-us" className="hover:text-cyan-300 transition">About</Link>
            <Link to="/privacy-policy" className="hover:text-cyan-300 transition">Privacy Policy</Link>
            <Link to="/terms-of-use" className="hover:text-cyan-300 transition">Terms of Use</Link>
            <Link to="/contact-us" className="hover:text-cyan-300 transition"> Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default OrgsteadHome;